import {AfterViewInit, Component, Input, ViewChild} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {ProposalFormBase} from '../proposal-form-base/proposal-form-base.component';
import {Proposal} from 'src/app/model/proposal/proposal';
import {BinaryData} from '../../../model/proposal/binary-data';
import {UploadLocation} from 'src/app/enum/upload-location';
import {UploadComponent} from '../../upload-field/upload.component';
import {ProposalInformation} from '../../../model/proposal/proposal-information';

@Component({
    selector: 'app-individual-clauses-conditions-form',
    templateUrl: './individual-clauses-conditions-form.component.html',
    styleUrls: ['../../../../styles/form-input.scss'],
    providers: [{ provide: ProposalFormBase, useExisting: IndividualClausesConditionsFormComponent }],
    standalone: false
})
export class IndividualClausesConditionsFormComponent extends ProposalFormBase implements AfterViewInit{

  @Input() proposalPreviewInformation: ProposalInformation;

  @ViewChild(UploadComponent) uploadComponent: UploadComponent;

  formGroup = this.fb.group({
    individualClausesFreeText: '',
    individualConditionsFreeText: '',
    individualClausesConditionsFiles: new FormControl<BinaryData[]>([]),
  });
  UploadLocation = UploadLocation;

  constructor(private readonly fb: FormBuilder) {
    super();
  }

  ngAfterViewInit(): void {
    if (this.proposalPreviewInformation != null) {
      this.formGroup.controls.individualClausesFreeText.patchValue(this.proposalPreviewInformation.individualClausesFreeText);
      this.formGroup.controls.individualConditionsFreeText.patchValue(this.proposalPreviewInformation.individualConditionsFreeText);
      if (this.proposalPreviewInformation.attachedFiles != null) {
        this.uploadComponent.addPreUploadedFiles(
            this.proposalPreviewInformation.attachedFiles.filter(file => file.uploadLocation == UploadLocation.INDIVIDUALCLAUSESCONDITIONS)
        );
      }
    }
  }

  updateProposal(proposal: Proposal): void {
    (this.formGroup.value.individualClausesConditionsFiles ?? []).forEach(file => {
      file.uploadLocation = UploadLocation.INDIVIDUALCLAUSESCONDITIONS;
      proposal.proposalInformation.attachedFiles.push(file);
    });
    proposal.proposalInformation.update(this.formGroup.value);
  }

  autoFillForTransmission(proposal: Proposal): void {
    if (proposal.proposalInformation != null) {
      this.formGroup.controls.individualClausesFreeText.patchValue(proposal.proposalInformation.individualClausesFreeText);
      this.formGroup.controls.individualConditionsFreeText.patchValue(proposal.proposalInformation.individualConditionsFreeText);
      if (proposal.proposalInformation.attachedFiles != null) {
        this.uploadComponent.addPreUploadedFiles(
          proposal.proposalInformation.attachedFiles.filter(file => file.uploadLocation == UploadLocation.INDIVIDUALCLAUSESCONDITIONS)
        );
      }
    }
  }

  autoFillForEdit(proposal: Proposal) {
    if (proposal.proposalInformation != null) {
      this.formGroup.controls.individualClausesFreeText.patchValue(proposal.proposalInformation.individualClausesFreeText);
      this.formGroup.controls.individualConditionsFreeText.patchValue(proposal.proposalInformation.individualConditionsFreeText);
      if (proposal.proposalInformation.attachedFiles != null) {
        this.uploadComponent.addPreUploadedFiles(
          proposal.proposalInformation.attachedFiles.filter(file => file.uploadLocation == UploadLocation.INDIVIDUALCLAUSESCONDITIONS)
        );
      }
    }
  }

  attachFiles(individualClausesConditionsFiles: BinaryData[]): void {
    this.formGroup.setValue({
      individualClausesFreeText: this.formGroup.value.individualClausesFreeText,
      individualConditionsFreeText: this.formGroup.value.individualConditionsFreeText,
      individualClausesConditionsFiles: individualClausesConditionsFiles
    });
  }

  reset() {
    this.formGroup.reset();
  }


}
